var _path, _path2, _circle, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHrms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 50 50",
    fill: "none",
    style: {
      display: "inline-block",
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2985 39.7923V30.667C28.2985 24.1909 23.6461 21.2205 18.0201 20.4766C16.3516 20.256 14.9805 21.6481 14.9805 23.3311C14.9805 25.0141 16.3689 26.3024 18.0035 26.7032C20.6277 27.3467 21.9781 28.9142 21.9781 31.1187V43.7595C21.9781 48.4898 28.2985 44.5226 28.2985 39.7923Z",
    fill: "#00BDF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4586 39.7923V30.667C31.4586 24.1909 36.1109 21.2205 41.737 20.4766C43.4054 20.256 44.7765 21.6481 44.7765 23.3311C44.7765 25.0141 43.3881 26.3024 41.7535 26.7032C39.1293 27.3467 37.7789 28.9142 37.7789 31.1187V43.7595C37.7789 48.4898 31.4586 44.5226 31.4586 39.7923Z",
    fill: "#00BDF2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.8785,
    cy: 15.5438,
    r: 4.74029,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66129 4.50008C6.85484 4.50008 5.5 6.74501 5.5 8.69109V42.3091C5.5 44.2551 6.85484 46.5001 8.66129 46.5001V4.50008Z",
    fill: "#00BDF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66129 4.50008C10.4677 4.50008 11.8226 6.74501 11.8226 8.69109V42.3091C11.8226 44.2551 10.4677 46.5001 8.66129 46.5001V4.50008Z",
    fill: "#00BDF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrms);
export default __webpack_public_path__ + "static/media/hrms.a09ac3d3709fb367b72ce97451535a1a.svg";
export { ForwardRef as ReactComponent };